<script setup lang="ts">
import ContextMenu from 'primevue/contextmenu'
import { useToast as usePrimeToast } from 'primevue/usetoast'
import type { MenuItem } from 'primevue/menuitem'
import { useChooseFile } from '~/layers/cms/app/composables/chooseFile'
import { usePublish } from '~/layers/cms/app/composables/publish'
import ManagePagesMenu from './Pages/managePageMenu.vue'
import ManageUsersMenu from './Users/manageUsersMenu.vue'
import { useDialog } from 'primevue/usedialog'
import { logout } from '~/layers/cms/app/composables/auth'
import { navigateTo } from 'nuxt/app'
import { ref } from 'vue'
import { useGlobalContextMenuShowControl } from '~/layers/cms/app/composables/useGlobalContextMenuShowControl'
import { saveCmsData, saveGlobalCmsData } from '~/layers/cms/app/composables/cms'
import { hideAll, useContextMenus, wasCleaned } from '#imports'

const { isShift } = useGlobalContextMenuShowControl()

const { chooseFile } = useChooseFile()
const toast = usePrimeToast()
const dialog = useDialog()
const { blockPublish, GetPublishStatus, publishIcon, getPublishLabel, publishPage } = usePublish()

const zapiszZmiany = async () => {
  const actions = [
    { fn: () => saveCmsData(), msg: 'Zapisano wszystko' },
    { fn: () => saveGlobalCmsData(), msg: 'Zapisano wszystko' }
  ]

  for (const { fn, msg } of actions) {
    const res = await fn()
    toast.add({
      severity: res.status_ok ? 'info' : 'error',
      summary: res.status_ok ? 'Info' : 'Error',
      detail: res.status_ok ? msg : `Error: ${res.message}`,
      life: 3000
    })
  }
}
const wyloguj = async () => {
  const response = await logout()
  if (response.status_ok) {
    navigateTo('/')
    location.reload()
  } else {
    toast.add({
      severity: response.status_ok ? 'info' : 'error',
      summary: response.status_ok ? 'Info' : 'Error',
      detail: response.status_ok ? response : `Error: ${response.message}`,
      life: 3000
    })
  }
}
const managePages = () => {
  dialog.open(ManagePagesMenu, {
    props: {
      header: 'Zarządzanie stronami',
      style: {
        width: '80vw',
        height: '80vh'
      },
      modal: true
    },
    data: {
      choose: false
    }
  })
}
const manageUsers = () => {
  dialog.open(ManageUsersMenu, {
    props: {
      header: 'Zarządzanie userami',
      style: {
        width: '80vw',
        height: '80vh'
      },
      modal: true
    },
    data: {
      choose: false
    }
  })
}

const globalMenuItems = ref<MenuItem[]>([])

const { cms_custom_list_block_contextMenuItems, cms_video_element_contextMenuItems, cms_link_element_contextMenuItems, cms_imege_element_contextMenuItems, cms_custom_component_contextMenuItems, cms_custom_component_list_contextMenuItems } = useContextMenus()

const buildMenu = () => {
  const items: MenuItem[] = []

  if (cms_imege_element_contextMenuItems.value) items.push(cms_imege_element_contextMenuItems.value)
  if (cms_video_element_contextMenuItems.value) items.push(cms_video_element_contextMenuItems.value)
  if (cms_custom_list_block_contextMenuItems.value) items.push(cms_custom_list_block_contextMenuItems.value)
  if (cms_link_element_contextMenuItems.value) items.push(cms_link_element_contextMenuItems.value)
  if (cms_custom_component_contextMenuItems.value) items.push(cms_custom_component_contextMenuItems.value)
  if (cms_custom_component_list_contextMenuItems.value) items.push(cms_custom_component_list_contextMenuItems.value)

  items.push(
    { label: 'Panel admina', command: () => navigateTo('/admin/home/') },
    { label: 'Users', command: () => manageUsers() },
    { label: 'Strony', command: () => managePages() },
    { label: 'Zarządzaj plikami', command: async () => await chooseFile(false) },
    { label: 'Zapisz', command: () => zapiszZmiany() },
    { label: () => getPublishLabel(), command: () => publishPage(), disabled: () => blockPublish.value },
    { label: 'Wyloguj', command: () => wyloguj() }
  )
  globalMenuItems.value = items
  wasCleaned.value = false
  hideAll()
}
</script>

<template>
  <ContextMenu
    v-if="!isShift"
    ref="dialogRef"
    global
    :model="globalMenuItems as unknown as MenuItem[]"
    @before-show="() => { GetPublishStatus(); buildMenu() }"
  />
</template>
